import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";

@Component({
  selector: "palliative-visits-table",
  templateUrl: "palliative-visits-table.html",
})
export class PalliativeVisitsTable implements OnInit, OnDestroy {
  @Input() palliativeVisitRates: any[];
  @Output() onRateChanged = new EventEmitter<any>();
  @Input() modifiers: boolean = false;

  ngOnDestroy(): void {}

  ngOnInit(): void {}

  constructor() {}

  rateChanged(visitRate, i) {
    this.palliativeVisitRates[i].Error = this.checkValidModifiers(visitRate);
    this.onRateChanged.emit(this.palliativeVisitRates);
  }

  checkChar(event: any, type) {
    let newValue = event.target.value;
    if (type == "alphaNumeric") {
      let regExp = new RegExp("^[A-Za-z0-9?]+$");
      if (!regExp.test(newValue)) {
        event.target.value = newValue.replace(/[^A-Za-z0-9]/g, "");
      }
    }
  }

  checkValidModifiers(visitRate) {
    if (
      (visitRate.M1 && visitRate.M1.length == 1) ||
      (visitRate.M2 && visitRate.M2.length == 1) ||
      (visitRate.M3 && visitRate.M3.length == 1) ||
      (visitRate.M4 && visitRate.M4.length == 1)
    )
      return "lengthError";

    if (visitRate.M4 && visitRate.M4.length > 0) {
      return visitRate.M3 &&
        visitRate.M3.length > 0 &&
        visitRate.M2 &&
        visitRate.M2.length > 0 &&
        visitRate.M1 &&
        visitRate.M1.length > 0
        ? ""
        : "orderError";
    } else if (visitRate.M3 && visitRate.M3.length > 0) {
      return visitRate.M2 &&
        visitRate.M2.length > 0 &&
        visitRate.M1 &&
        visitRate.M1.length > 0
        ? ""
        : "orderError";
    } else if (visitRate.M2 && visitRate.M2.length > 0) {
      return visitRate.M1 && visitRate.M1.length > 0 ? "" : "orderError";
    }

    return "";
  }
}



// WEBPACK FOOTER //
// ./src/components/payers/rates-payer/palliative-visits/palliative-visits-table/palliative-visits-table.ts